import { useQuery } from "@tanstack/react-query";
import { axiosGet } from "@/services/axiosService";

export default function useSalesForceConfig() {
  return useQuery({
    queryKey: ["salesforceConfig"],
    queryFn: async () => {
      const response = await axiosGet("/configurations/salesforce/accounts");

      return response?.data?.data?.configs ?? null;
    },
    staleTime: Infinity,
  });
}
